import React, { useEffect, useState } from 'react'

// redux
import { connect, useDispatch, useSelector } from 'react-redux'

// actions (mirrors banner but for broadcastgame)
import { getBroadcastGame, deleteBroadcastGame, handleVIPSwitchBroadcastGame } from '../../store/BroadcastGame/action'

// config
import { baseURL } from '../../util/Config'

// routing
import { Link } from 'react-router-dom'

// MUI
import { TablePagination, Tooltip } from '@mui/material'

// types (mirrors banner but for broadcastgame)
import { OPEN_BROADCASTGAME_DIALOG } from '../../store/BroadcastGame/types'

// dialog (mirrors banner but for broadcastgame)
import BroadcastGameDialog from '../dialog/BroadcastGameDialogue'

// sweet alert helpers
import { alert, warning } from '../../util/Alert'

import $ from 'jquery'

// image fallback
import noImage from '../../assets/images/noImage.png'
import Pagination from '../../pages/Pagination'
import { usePermission } from '../context/PermissionProvider'


const TablePaginationActions = React.lazy(() => import('./TablePagination'))

const BroadcastGameTable = (props) => {
  const dispatch = useDispatch()
  const { can } = usePermission();
  const canCreate = can('admin/broadcastgame', 'Create');
  const canEdit = can('admin/broadcastgame', 'Edit');
  const canDelete = can('admin/broadcastgame', 'Delete');

  const [data, setData] = useState([])

  useEffect(() => {
    dispatch(getBroadcastGame())
  }, [dispatch])

  const broadcastgame = useSelector(state => state.broadcastgame.broadcastgame)
  console.log('broadcastgame: ', broadcastgame);

  useEffect(() => {
    setData(broadcastgame)
  }, [broadcastgame])

  $(document).ready(function () {
    $('img').bind('error', function () {
      $(this).attr('src', noImage)
    })
  })

  const handleSearch = (e) => {
    const value = e.target.value.trim().toUpperCase()
    if (value) {
      const filtered = broadcastgame.filter((row) => {
        return row?.URL?.toUpperCase()?.indexOf(value) > -1
      })
      setData(filtered)
    } else {
      setData(broadcastgame)
    }
  }
  const handleIsTop = (id) => {


    dispatch(handleVIPSwitchBroadcastGame(id));
  };

  const handleOpen = () => {

    dispatch({ type: OPEN_BROADCASTGAME_DIALOG })
  }

  const handleDelete = (id) => {

    const ask = warning()
    ask
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteBroadcastGame(id)
          alert('Deleted!', 'Broadcast game has been deleted!', 'success')
        }
      })
      .catch((err) => console.log(err))
  }

  const handleEdit = (row) => {

    dispatch({ type: OPEN_BROADCASTGAME_DIALOG, payload: row })
  }

  return (
    <>
      <div className='page-title'>
        <div className='row'>
          <div className='col-12 col-md-6 order-md-1 order-last'>
            <h3 className='mb-3 text-white'>Broadcast Game</h3>
          </div>
          <div className='col-12 col-md-6 order-md-2 order-first'>
            <nav aria-label='breadcrumb' className='breadcrumb-header float-start float-lg-end'>
              <ol className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <Link to='/admin/dashboard' className='text-danger'>
                    Dashboard
                  </Link>
                </li>
                <li className='breadcrumb-item active' aria-current='page'>
                  Broadcast Game
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <div className='card'>
            <div className='card-header pb-0'>
              <div className='row my-3'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left'>
                  {canCreate && <button
                    type='button'
                    className='btn waves-effect waves-light btn-danger btn-sm float-left'
                    onClick={handleOpen}
                    id='broadcastGameDialog'
                  >
                    <i className='fa fa-plus'></i>
                    <span className='icon_margin'>New</span>
                  </button>
                  }
                </div>

                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mt-lg-0 mt-xl-0'>
                  {/* Mirror banner's optional search UI */}
                  {/* <form action=''>
                    <div className='input-group mb-3 border rounded-pill'>
                      <div className='input-group-prepend border-0'>
                        <div id='button-addon4' className='btn text-danger'>
                          <i className='fas fa-search mt-2'></i>
                        </div>
                      </div>
                      <input
                        type='search'
                        placeholder={`What're you searching for?`}
                        aria-describedby='button-addon4'
                        className='form-control bg-none border-0 rounded-pill searchBar'
                        onChange={handleSearch}
                      />
                    </div>
                  </form> */}
                </div>
              </div>
            </div>

            <div className='card-body card-overflow'>
              <table className='table table-striped'>
                <thead className='text-center'>
                  <tr>
                    <th>No.</th>
                    <th>Image</th>
                    <th>URL</th>
                    {canEdit && <th>Is Active</th>}
                    {canEdit && <th>Edit</th>}
                    {canDelete && <th>Delete</th>}
                  </tr>
                </thead>

                <tbody className='text-center'>
                  {data?.length > 0 ? (
                    data.map((row, index) => (
                      <tr key={row?._id || index}>
                        <td>{index + 1}</td>
                        <td>
                          <img
                            height='70px'
                            width='100px'
                            alt='broadcastgame'
                            src={row?.imageUrl ? baseURL + row?.imageUrl : noImage}
                            style={{
                              boxShadow: '0 5px 15px 0 rgb(105 103 103 / 0%)',
                              border: '2px solid #fff',
                              borderRadius: 10,
                              display: 'block'
                            }}
                            className='mx-auto'
                          />
                        </td>
                        <td>
                          <Link to={row?.URL || '#'} target='_blank'>
                            {row?.redirectUrl ? row?.redirectUrl : '-'}
                          </Link>
                        </td>
                        {canEdit && (
                          <td>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={row?.isActive}
                                onChange={() => handleIsTop(row?._id)}
                              />
                              <span className="slider">
                                <p
                                  style={{
                                    fontSize: 12,
                                    marginLeft: `${row?.isActive ? "-24px" : "35px"
                                      }`,
                                    color: "#000",
                                    marginTop: "6px",
                                  }}
                                >
                                  {row?.isActive ? "Yes" : "No"}
                                </p>
                              </span>
                            </label>
                          </td>
                        )}

                        {canEdit &&
                          <td>
                            <Tooltip title='Edit'>
                              <button
                                type='button'
                                className='btn btn-sm btn-info'
                                onClick={() => handleEdit(row)}
                              >
                                <i className='fa fa-edit fa-lg'></i>
                              </button>
                            </Tooltip>
                          </td>
                        }{canDelete &&
                          <td>
                            <Tooltip title='Delete'>
                              <button
                                type='button'
                                className='btn btn-danger btn-sm'
                                onClick={() => handleDelete(row?._id)}
                              >
                                <i className='fas fa-trash-alt fa-lg'></i>
                              </button>
                            </Tooltip>
                          </td>
                        }
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <BroadcastGameDialog />
    </>
  )
}

export default connect(null, { getBroadcastGame, deleteBroadcastGame })(BroadcastGameTable)
